import VisnetHubFaultWaveforms from '@/resources/visnet-hub-fault-events-waveforms';
import PaginatedList from './mixins/paginated-list';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import jsona from '@/lib/jsona';
import { createSeries } from '@/utils/store/phasesFeedersHelpers';

const DEFAULT_STATE = {
  eventTimestamp: null
};
const baseStore = {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  namespaced: true,
  ...PaginatedList(
    VisnetHubFaultWaveforms,
    {
      state: DEFAULT_STATE,
      mutations: {
        setActiveEventTimestamp(state, newTimestamp = null) {
          state.eventTimestamp = newTimestamp;
        }
      },
      getters: {
        getWaveformSeries: state => createSeries(state.data)
      }
    },
    'visnetHubFaultWaveforms'
  )
};

export default {
  ...baseStore,
  mutations: {
    ...baseStore.mutations,
    parseResponseData(state, data) {
      const { currentPage, totalPages, nextPage, prevPage, totalCount } = camelcaseKeysDeep(
        data.meta
      );
      state.data = Object.freeze(camelcaseKeysDeep(jsona.deserialize(data)));
      state.currentPage = currentPage;
      state.totalPages = totalPages;
      state.nextPage = nextPage;
      state.prevPage = prevPage;
      state.totalCount = totalCount;
      state.loading = false;
    },
    setActiveEventTimestamp(state, newTimestamp) {
      state.eventTimestamp = newTimestamp;
    }
  }
};
